import ResetPasswordPage from './ResetPasswordPage';
import ResetPasswordPageContainer from './ResetPasswordPage.container';

export default ResetPasswordPageContainer(ResetPasswordPage);
